// @flow
import React, { useContext } from 'react';
import classnames from 'classnames';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { heights } from 'Components/widgets/navigation/Navigation.constants';

import { type BadgeProps } from 'Components/frameworks/badge/Badge.jsx';
import { ImmersiveSlideShow } from 'Components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx';
import { Multimedia, type MultimediaResources } from 'Components/widgets/multimedia/Multimedia.jsx';
import { ProductImmersiveNarrow } from './product-immersive-narrow/ProductImmersiveNarrow.jsx';

type Props = {
  badgeIcon?: BadgeProps,
  className?: string,
  closeLabel?: string,
  galleryLabel?: string,
  hasInsetBorder?: boolean,
  id?: string,
  infos: Array<string>,
  media: Array<string>,
  multimedia: MultimediaResources,
  multimediaLabels: {
    photos?: string,
    socialPictures?: string,
    videos360?: string,
    videos?: string,
  },
  nextLabel?: string,
  previousLabel?: string,
  size?: ImmersiveSizeProps,
  title: string,
};

export function ProductImmersive(props: Props) {
  const {
    badgeIcon,
    className,
    closeLabel,
    galleryLabel,
    hasInsetBorder,
    id,
    infos = [],
    media = [],
    multimedia,
    multimediaLabels,
    nextLabel,
    previousLabel,
    size = 'large',
    title,
  } = props;

  const { isDesktop } = useContext(ResponsiveContext);

  if (!media.length) return null;

  const multimediaStyle = isDesktop ? { bottom: '45px' } : { bottom: '80px' };

  return (
    <div className={classnames('relative', className)} {...(id ? { id } : null)}>
      {isDesktop ? (
        <ImmersiveSlideShow
          hasInsetBorder={hasInsetBorder}
          immersiveSize={size}
          insetBorderOffset={heights.NAVIGATION_LARGE_HEIGHT}
          media={media}
          nextLabel={nextLabel}
          previousLabel={previousLabel}
        />
      ) : (
        <ProductImmersiveNarrow
          badgeIcon={badgeIcon}
          hasInsetBorder={hasInsetBorder}
          infos={infos}
          media={media}
          nextLabel={nextLabel}
          previousLabel={previousLabel}
          size={size}
          title={title}
        />
      )}
      <div className="absolute w-full" style={multimediaStyle}>
        <Multimedia
          galleryLabel={galleryLabel}
          closeLabel={closeLabel}
          isOverlay
          labels={multimediaLabels}
          medias={multimedia}
          nextLabel={nextLabel}
          previousLabel={previousLabel}
        />
      </div>
    </div>
  );
}
